import { render } from "./blog-side.vue?vue&type=template&id=3bc18485"
import script from "./blog-side.vue?vue&type=script&lang=js"
export * from "./blog-side.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__